export default __webpack_public_path__ + "static/media/vector-car.f9c55eb2.png";